<div class="row sale4allStyle1" style="width: 100%">
    <div class="col-5">
        <lable class="labelElm"><b>{{question.label}}</b></lable>
    </div>
    <div class="col-7">
        <input [ngModel]="question.value" disabled  type="text">
    </div>
</div>